import { render } from "./ProductLegalComplianceInformation.vue?vue&type=template&id=a234aa00"
import script from "./ProductLegalComplianceInformation.vue?vue&type=script&lang=js"
export * from "./ProductLegalComplianceInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__